import React from 'react';

const STAGE = process.env.REACT_APP_DEPLOY_STAGE;
const API_URL = process.env.REACT_APP_API_URL || '';

// Hostnames that must never show the dev banner regardless of build-time env.
// Defense-in-depth: matches the consumer-app guard so a prod build with
// REACT_APP_DEPLOY_STAGE accidentally set cannot leak the banner onto the
// real admin domain.
const PROD_HOSTS = new Set(['admin.picklecourts.rent']);

export default function DevEnvBanner() {
  if (STAGE !== 'development' && STAGE !== 'preview') return null;
  if (typeof window !== 'undefined' && PROD_HOSTS.has(window.location.hostname)) {
    return null;
  }

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: '#b45309',
        color: '#fff',
        textAlign: 'center',
        fontSize: '11px',
        fontWeight: 700,
        letterSpacing: '0.6px',
        textTransform: 'uppercase',
        padding: '4px 8px',
      }}
    >
      {`Dev preview · ${API_URL.replace(/^https?:\/\//, '') || 'no api'}`}
    </div>
  );
}
